var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.disabled && (!_vm.limit || _vm.fileList.length < _vm.limit)
        ? _c(
            "el-upload",
            _vm._b(
              {
                ref: "upload",
                attrs: {
                  accept: "image/*",
                  headers: _vm.headers,
                  action: _vm.action,
                  multiple: false,
                  "file-list": _vm.fileList,
                  "before-upload": _vm.beforeUpload,
                  "on-success": _vm.successUpload,
                  "show-file-list": false,
                  "on-progress": _vm.progressUpload,
                  "on-error": _vm.errorUpload,
                  limit: _vm.limit,
                },
              },
              "el-upload",
              _vm.$attrs,
              false
            ),
            [
              _vm._t(
                "default",
                function () {
                  return [
                    _c(
                      "div",
                      { staticClass: "picture_upload flex-center-center" },
                      [_c("i", { staticClass: "el-icon-plus" })]
                    ),
                  ]
                },
                { fileList: _vm.fileList }
              ),
              _vm._t("tip"),
            ],
            2
          )
        : _vm._e(),
      _vm.showFileList
        ? _c(
            "transition-group",
            {
              staticClass: "transition_container",
              attrs: { name: "fade", tag: "div" },
            },
            _vm._l(_vm.fileList, function (item, index) {
              return _c(
                "div",
                { key: index, staticClass: "picture_box" },
                [
                  item.url
                    ? _c("el-image", {
                        ref: "elImage",
                        refInFor: true,
                        attrs: {
                          src: item.url,
                          "preview-src-list": _vm.previewSrcList,
                        },
                      })
                    : _c(
                        "el-avatar",
                        { attrs: { shape: "square", size: 100 } },
                        [_vm._v("上传中")]
                      ),
                  item.status == "success" && !_vm.disabled
                    ? _c(
                        "div",
                        {
                          staticClass: "picture_box_action flex-center-center",
                        },
                        [
                          _c("i", {
                            staticClass: "el-icon-zoom-in icon",
                            on: {
                              click: function ($event) {
                                return _vm.handlePreview(item)
                              },
                            },
                          }),
                          _c("i", {
                            staticClass: "el-icon-delete icon",
                            on: {
                              click: function ($event) {
                                return _vm.handleRemove(item, index)
                              },
                            },
                          }),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              )
            }),
            0
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }